import React from 'react';
import './SecurityContent.css';
import SECIMG from '../../assets/images/sec.png'; 

const SecurityContent = () => {
  return (
    <section className="security-page-content-section">
      <div className="container">
        {/* Top Intro Section */}
        <div className="security-intro-grid">
          <div className="security-intro-image-container">
            <img 
              src={SECIMG}
              alt="SAP Security" 
              className="security-intro-image"
            />
          </div>
          <div className="security-intro-text">
            <h2 className="security-intro-title">Why Choose Our SAP Security Solutions Services</h2>
            <p>
              At NEUROVERSE AI, we offer expert Enterprise SAP Security Consulting Services in the UAE, ensuring your business’s SAP systems are secure and compliant. Our SAP Security Risk Management Consulting in the USA helps businesses identify, assess, and mitigate security risks effectively. Whether you need SAP Security Consulting Services in the USA or SAP Security Solutions for Businesses, we provide tailored solutions to safeguard your valuable data.
            </p>
          </div>
        </div>

        {/* Features Grid Section */}
        <div className="security-features-grid">
          <div className="security-feature-card">
            <h3>Empower Your Team with SAP Security Consulting Services</h3>
            <p>
              In addition to implementing SAP Security measures, we provide comprehensive programs to empower your workforce. Our SAP Security courses are designed to equip IT professionals with the knowledge and skills to manage security effectively within SAP systems.
            </p>
          </div>
          <div className="security-feature-card">
            <h3>Protect Your SAP Environment with Robust Security Measures</h3>
            <p>
              Our SAP Security services are designed to address the unique challenges of safeguarding your enterprise systems. We secure your SAP S/4HANA and legacy systems through role-based access controls (RBAC), secure identity and authentication management, and compliance with GDPR, SOX, and other regulatory standards.
            </p>
          </div>
          <div className="security-feature-card">
            <h3>Seamless Integration of SAP Security Solutions</h3>
            <p>
              Neuroverse AI specializes in integrating advanced SAP Security tools, ensuring seamless protection without disrupting your operations. From system audits to real-time monitoring, we help businesses maintain a secure environment while optimizing performance.
            </p>
          </div>
          <div className="security-feature-card">
            <h3>Secure Your SAP Ecosystem with Neuroverse AI</h3>
            <p>
              Neuroverse AI empowers organizations to protect their SAP ecosystems with next-generation AI-driven security solutions. Our platform integrates seamlessly with SAP environments, providing unmatched capabilities in threat detection, risk management, and real-time response.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SecurityContent;
